import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, forkJoin, map, mergeMap, of } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { FehApiActions } from '@feh/shared-api';

import {
  loadTimeslots,
  loadTimeslotsError,
  receivedTimeslotsForDay,
} from './get-timeslots.actions';
import { GetTimeslotsTimesService } from './api/get-timeslots-times.service';

const MAX_DAYS = 5;

@Injectable()
export class GetTimeslotsEffects {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(GetTimeslotsTimesService);

  retrieveTimeslotsDays$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadTimeslots),
      map(() => FehApiActions.getDaysV1.requestAction({ payload: {} }))
    )
  );

  handleTimeslotsDaysError$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FehApiActions.getDaysV1.errorAction),
      map(() => loadTimeslotsError())
    )
  );

  retrieveTimeslots$ = createEffect(() =>
    this.actions$.pipe(
      ofType(FehApiActions.getDaysV1.successAction),
      mergeMap((responseBody) =>
        forkJoin(
          (responseBody.payload.data ?? [])
            .slice(0, MAX_DAYS)
            .map((day) =>
              this.apiService.call$({ dateStart: `${day}T00:00:00` })
            )
        ).pipe(
          mergeMap((timeslotTimes) => {
            // remove all empty dateslots
            timeslotTimes = timeslotTimes.filter((t) => t.dateslots.length > 0);

            return timeslotTimes.map((t) =>
              receivedTimeslotsForDay({
                day: t.dateslots[0].date,
                timeslots: t.dateslots[0].timeslots,
              })
            );
          }),
          catchError(() => of(loadTimeslotsError()))
        )
      )
    )
  );
}
